<template>


    <div class="children-container">
        <div class="children-module-name"><span>子账户管理</span></div>
        <div class="children-module-info">
            <div v-if="companyList.length === 0 && companyFlag == true">
                <a-empty style="margin-top: 10%;" description="您暂无权限使用该功能" />
            </div>
            <div v-else>
                <div>
                    <a-form-model ref="formModel" layout="inline" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-form-model-item label="机构">
                            <a-select style="width: 200px" @change="companyChange" v-model="unit_id"
                                placeholder="请选择机构">
                                <a-select-option v-for="(item, index) in companyList" :key="index" :value="item.id">
                                    {{item.name}}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>

                        <a-button style="margin-bottom: 20px;border-radius: 0px 16px 0px 16px;margin-left: 20px;"
                            type="primary" @click="openModal" icon="plus">添加
                        </a-button>
                    </a-form-model>
                </div>
                <a-table :columns="formModelColumns" bordered :data-source="list" rowKey="id" :pagination="false">
                    <template slot="state" slot-scope="text, record">
                        <a-tag color="green" v-if="text == 'TRUE'">正常</a-tag>
                        <a-tag color="red" v-if="text == 'FALSE'">未同意</a-tag>
                    </template>
                    <template slot="action" slot-scope="text, record">
                        <a-button v-if="record.state == 'FALSE'" type="link" size="small" icon="edit" style="color: #007F76"
                            @click="successData(record['id'])">
                            通过
                        </a-button>
                        <a-button type="link" size="small" icon="delete" style="color: red"
                            @click="openDelete(record['id'])">
                            删除
                        </a-button>
                    </template>
                </a-table>
                <div class="page-container">
                    <a-pagination :page-size.sync="page.pageSize" :total="page.totalRow" v-model="page.start"
                        @change="changePage" />
                </div>
            </div>
            <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="modalVisible" title="子账户管理"
                @ok="actionData" :width="650" :destroyOnClose="true" :disabled="$store.state.requestLoading">
                <a-form-model style="padding-left: 80px;" ref="formModel" :rules="baseRules" :model="formModel"
                    layout="vertical" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                    <a-form-model-item label="姓名" prop="name">
                        <a-input placeholder="请输入姓名" v-model="formModel.name"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="手机号" prop="mobile">
                        <a-input placeholder="请输入手机号" v-model="formModel.mobile"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="账户类型" prop="type_id">
                        <a-select v-model="formModel.type_id" placeholder="请选择账户类型">
                            <a-select-option v-for="(item, index) in accountTypeList" :key="index" :value="item.id">
                                {{item.title}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="邮箱" prop="mail">
                        <a-input placeholder="请输入邮箱" v-model="formModel.mail"></a-input>
                    </a-form-model-item>
                </a-form-model>
            </a-modal>
        </div>
    </div>
</template>

<script>
    import * as Api from './api';
    import * as commonApi from '@/commonApi';

    export default {
        data() {
            let validatePhone = (rule, value, callback) => {
                if (!commonApi.MobileReg.test(value)) {
                    callback(new Error("请输入正确的手机号"));
                }
                callback();
            };
            return {
                companyList: [],
                companyFlag: false,
                unit_id: undefined,
                accountTypeList: [],
                formModel: {
                    name: '',
                    mobile: '',
                    mail: '',
                    unit_id: '',
                    type_id: undefined

                },
                formModelColumns: [

                    {
                        title: "姓名",
                        dataIndex: "name",
                        scopedSlots: { customRender: "name" },
                        width: 150
                    },
                    {
                        title: "手机号",
                        dataIndex: "mobile",
                        scopedSlots: { customRender: "mobile" },
                        width: 150
                    },
                    {
                        title: "邮箱",
                        dataIndex: "mail",
                        scopedSlots: { customRender: "mail" },
                        width: 180
                    },
                    {
                        title: "状态",
                        dataIndex: "state",
                        scopedSlots: { customRender: "state" },
                        width: 100
                    },
                    {
                        title: "操作",
                        dataIndex: "action",
                        key: "action",
                        width: 200,
                        scopedSlots: { customRender: "action" },
                    },
                ],
                modalVisible: false,
                baseRules: {
                    name: [{ required: true, message: '请选择姓名', trigger: 'change' }],
                    mobile: [{ required: true, message: '请输入手机号', trigger: 'change' }, { validator: validatePhone, trigger: 'change' }],
                    type_id: [{ required: true, message: '请选择账户类型', trigger: 'change' }],
                },

                list: [],
                page: {
                    start: 1,
                    limit: 20,
                    pageSize: 0,
                    totalRow: 0,
                    unit_id: ''
                },
                companySelectVisible: false,
            };
        },
        mounted() {
            this.getCompanyList();
            this.getAccountTypeList();
        },
        methods: {

            // 打开添加框
            openModal() {
                // this.formModelRules = Object.assign({}, this.baseRules, this.deRules)
                if (!this.unit_id) {
                    this.$message.error('请先选择机构');
                    return;
                }
                this.formModel.name = '';
                this.formModel.mobile = '';
                this.formModel.mail = '';
                this.formModel.type_id = undefined;
                this.modalVisible = true;
            },

            // 获取单位列表
            async getCompanyList() {
                let res = await Api.GetCompanyList({});
                if (res && res["code"] == "0") {
                    this.companyList = res.list;
                    this.companyFlag = true;
                }
            },

            // 获取账户类型列表
            async getAccountTypeList() {
                let res = await Api.GetAccountTypeList({});
                if (res && res["code"] == "0") {
                    this.accountTypeList = res.list;
                }
            },

            // 修改单位名称
            companyChange(e) {
                this.page.unit_id = e;
                this.getList()
            },

            // 获取列表
            async getList() {
                let res = await Api.GetList(this.page);
                if (res && res["code"] == "0") {
                    this.page.totalRow = res.page.totalRow;
                    this.page.pageSize = res.page.pageSize;
                    this.list = res.page.list;
                }
            },

            // 添加/编辑
            async actionData() {
                this.$refs.formModel.validate(async valid => {
                    if (valid) {

                        let temp = Object.assign({}, this.formModel);
                        temp.unit_id = this.unit_id;
                        let res = res = await Api.Save(temp);

                        if (res && res.code == 0) {
                            this.$message.success(res.message);
                            this.page.unit_id = this.unit_id;
                            this.getList();
                            this.modalVisible = false;
                        } else {
                            this.$message.error(res.message);
                        }
                    }
                });
            },
            // 通过
            async successData(id) {
                let res = res = await Api.Pass({id: id});
                if (res && res.code == 0) {
                    this.$message.success(res.message);
                    this.getList();
                } else {
                    this.$message.error(res.message);
                }
            },
            // 删除
            openDelete(id) {
                let that = this;
                this.$confirm({
                    title: "信息提示",
                    okType: "danger",
                    content: "您确定要删除吗",
                    okText: "确定",
                    cancelText: "取消",
                    async onOk() {
                        let res = await Api.Delete({ id: id });
                        if (res && res["code"] == "0") {
                            that.getList();
                            that.$message.success(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    },
                    onCancel() {
                    },
                });
            },

            // 改变分页
            changePage(e) {
                this.page.start = currentPage;
                this.getList();
            },
        },
    };
</script>

<style lang="less">
    .tips-text {
        font-size: 14px;
        font-weight: 500;
        color: #007F76;
        line-height: 38px;
        padding-top: 2px;
    }

    .children-module-content {
        padding: 25px !important;
        background-color: #fff !important;
    }

    .list {
        border: 1px solid #ECECEC;
        padding: 30px;
        display: flex;
        align-items: center;
    }

    .list .label {
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
        margin-right: 10px;
    }

    .list .info {
        flex: 1;
    }

    .list .action {
        width: 150px;
        display: flex;
        align-items: center;
        justify-content: flex-end
    }

    .list .default {
        font-size: 12px;
        font-weight: 500;
        text-decoration: underline;
        color: #008276;
        line-height: 30px;
        margin-left: 10px;
    }

    .list .name {
        font-size: 12px;
        color: #999999;
        line-height: 30px;
    }

    .inner-item {
        line-height: 20px;
    }

    .company-list {
        border: 1px solid #eee;
        font-size: 12px;
        overflow-y: scroll;
        max-height: 300px;
        position: absolute;
        background-color: #fff;
        z-index: 99999;
        width: 100%;
        font-weight: 600;
    }

    .company-item {
        line-height: 40px;
        border-bottom: 1px solid #eee;
        padding-left: 10px;
    }

    .company-list .company-item:hover {
        cursor: pointer;
        background: #F2F8F8;
    }

    .company-list .company-item:last-child {
        border-bottom: none;
    }
</style>